/*
 * Handle user associated credit card actions
 */
var CreditCardsService = (function() {

})();
